import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dev_active",
  "use": "dev_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dev_active\"><path fill-rule=\"evenodd\" d=\"M1 3c0-.552.445-1 .993-1h16.014c.548 0 .993.445.993 1v14c0 .552-.445 1-.993 1H1.993A.995.995 0 0 1 1 17V3Zm15 8.5L10.857 7v1.3l3.643 3.2-3.643 3.2V16L16 11.5Zm-12.143-2L9 5v1.3L5.357 9.5 9 12.7V14L3.857 9.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol